
import { defineComponent, ref } from 'vue';
import SimpleModal from './SimpleModal.vue';

export default defineComponent({
  name: 'TroubleshootingModal',

  components: {
    SimpleModal,
  },

  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    customerId: {
      type: String,
      default: '',
    },
  },

  emits: ['close'],

  setup() {
    const selectedProblem = ref('');

    return {
      selectedProblem,
    };
  },
});
